import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../images/location_new/miami/upscale_back.webp";
import { Link } from "gatsby";

function Richhouston() {
  return (
    <section
      className="rich_houston"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
            <h2>Want to Build an App to Upscale Your Business?</h2>
            <p>
              Partner up with TekRevol to upscale your business prospect with a
              purpose-built app solution.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Hire App Developers
            </Link>
          </Col>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="mt-auto">
            <div className="rich_houston_img">
              <StaticImage
                src="../../images/location_new/miami/upscale_miami.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={301}
                height={503}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Richhouston;
